import { Box, Image, Text } from '@bonanza-social/moonlight';
import { Promo } from '@bonanza-social/promos';
import { useTranslation } from 'react-i18next';

function ReffererPromoLimitReached({
  referrerPromo,
}: {
  referrerPromo: Promo;
}) {
  const { t } = useTranslation('inviteFriends');

  return (
    <Box flex={1} flexDirection="column">
      <Box gap="space-300">
        <Image
          source={referrerPromo?.bannerImageUrl}
          borderTopLeftRadius="radius-400"
          borderTopRightRadius="radius-400"
          width="100%"
          aspectRatio={2}
          contentFit="cover"
        />
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          locNS="inviteFriends"
          locKey="limit_reached_title"
        />
        <Box
          variant="gradient"
          gradient="citrusBackground"
          flexDirection="row"
          alignSelf="flex-start"
          alignItems="center"
          gap="space-100"
          paddingTop="space-050"
          paddingBottom="space-050"
          paddingLeft="space-200"
          paddingRight="space-200"
          borderRadius="radius-full"
        >
          <Text
            variant="body-s"
            color="accentSurfacePrimary"
            textAlign="center"
          >
            {t('limit_reached_badge_text', {
              invites: referrerPromo.playerExecutionCount,
            })}
          </Text>
        </Box>
        <Text variant="body-m" color="darkSurfacePrimary">
          {t('limit_reached_spin_text', {
            limit: referrerPromo.playerExecutionLimit,
          })}
        </Text>
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          marginTop="space-300"
          locNS="inviteFriends"
          locKey="limit_reached_spin_text2"
        />
      </Box>
    </Box>
  );
}

export default ReffererPromoLimitReached;
